import { Component, OnInit, ChangeDetectionStrategy, Input, OnDestroy, ViewChild, ChangeDetectorRef } from '@angular/core';
import { ExtractReportServiceFactory, ExtractReportService } from '../../services/ExtractReportService';
import { ExtractReportModel } from '../../models/ExtractReportModel';
import { Subject, Observable, Subscription } from 'rxjs';
import { merge } from 'rxjs/observable/merge';
import { of as observableOf } from 'rxjs/observable/of';
import { catchError } from 'rxjs/operators/catchError';
import { map } from 'rxjs/operators/map';
import { startWith } from 'rxjs/operators/startWith';
import { switchMap } from 'rxjs/operators/switchMap';
import { MatPaginator, MatSort, MatTableDataSource } from '@angular/material';
import { AlertsComponent } from '../../../pillar/alerts/components/alerts.component';
import { ReportParameterModel } from '../../models/ReportParameterModel';

@Component({
  selector: 'plr-extract-report-viewer',
  templateUrl: './extract-report-viewer.component.html',
  styleUrls: ['./extract-report-viewer.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush
})
export class ExtractReportViewerComponent implements OnInit, OnDestroy {
  _initialized = false;
  _reportService: ExtractReportService;
  _report: ExtractReportModel;
  _querySubscription: Subscription;
  parameters: ReportParameterModel[];
  destroyed$: Subject<boolean> = new Subject<boolean>();
  isExpanded = true;
  loading: boolean;
  totalCount: number = 0;
  displayedColumns: string[] = ['actions'];
  columns: any[] = [];
  dataSource = new MatTableDataSource<any>();
  currentDateTime = new Date();

  constructor(private _extractReportServiceFactory: ExtractReportServiceFactory, private _changeDetectorRef: ChangeDetectorRef) { }

  ngOnDestroy() {
    this.destroyed$.next(true);
    if (this._querySubscription) {
      this._querySubscription.unsubscribe();
      this._querySubscription = null;
    }
  }

  @ViewChild(MatPaginator)
  paginator: MatPaginator;
  @ViewChild(MatSort)
  sort: MatSort;
  @ViewChild(AlertsComponent)
  alerts: AlertsComponent;

  @Input()
  set report(report: ExtractReportModel) {
    this._report = report;
    this._reportService = this._extractReportServiceFactory.getService(report.extractControllerUrl);
    this.getReportMetadata();
  }
  get report(): ExtractReportModel {
    return this._report;
  }

  ngOnInit() {
    this.sort.sortChange
      .takeUntil(this.destroyed$)
      .subscribe(() => this.paginator.pageIndex = 0);
    this._initialized = true;
    if (this._reportService) {
      this.getReportMetadata();
    }
  }

  getReportMetadata() {
    if (this._initialized) {
      this.displayedColumns = [];
      this.columns = [];
      this.parameters = null;
      this._reportService
        .getExtractMetadata()
        .take(1)
        .subscribe(r => {
          var metadata = r.model.listMetadata;
          this.displayedColumns = [];
          for (var index in metadata) {
            this.displayedColumns.push(metadata[index].name);
            this.columns.push(metadata[index])
          }
          this.parameters = r.model.parameters;
          this.paginator.pageIndex = 0;
          this.refreshDataSource();
        });
    }
  }

  refreshDataSource(): void {
    this.dataSource = new MatTableDataSource<any>();
    if (this._querySubscription) {
      this._querySubscription.unsubscribe();
      this._querySubscription = null;
    }

    this.totalCount = undefined;

    this._reportService.totalCount(this.getParameters())
    .take(1)
    .subscribe(r => {
      this.totalCount = r.model;
    });

    this._querySubscription = merge(this.sort.sortChange, this.paginator.page)
      .pipe(
        startWith({}),
        switchMap(() => {
          this.loading = true;
          this._changeDetectorRef.markForCheck();
          return this._reportService.listQuery(this.getParameters(), this.paginator.pageIndex, this.paginator.pageSize, this.sort.active, this.sort.direction);
        }),
        map(data => {
          this.loading = false;
          this._changeDetectorRef.markForCheck();
          return data.items;
        }),
        catchError(() => {
          this.loading = false;
          this._changeDetectorRef.markForCheck();
          return observableOf([]);
        })
      ).subscribe(data => this.dataSource.data = data);
  }

  private getParameters(): any {
    var parameters = {};
    this.parameters.forEach(p => {
      if (p.value instanceof Array) {
        parameters[p.name] = [];
        p.value.forEach(d => {
          if(d !== '-1'){
            parameters[p.name].push(d.key || d);
          }
        });
      } else {
        parameters[p.name] = p.value;
      }
    });
    return parameters;
  }

  extract() {
    this._reportService.getExportUrl(this.getParameters(), this.paginator.pageIndex, this.paginator.pageSize, this.sort.active, this.sort.direction)
      .take(1)
      .subscribe(r => {
        this._reportService.openExtract(r.model, this.getParameters());
      });
  }

}



// WEBPACK FOOTER //
// ./src/app/report/components/extract-report-viewer/extract-report-viewer.component.ts